import combineReducers from 'redux/lib/combineReducers';

import knowledgeBase from './knowledgeBase';

export default combineReducers({
  knowledgeBase,
});
